module.exports = __webpack_public_path__ + "media/images/contact-bg-320-285dec6695acbc36e24aab8414170fff.png";